import whyUsContent from './content/why-us.json';

const whyUsMock = {
    layoutType: 2,
    data: {
        name: 'why-us',
        layoutType: 2,
        areasList: [
            {
                id: 'why-us-page-area',
                name: 'Content',
                componentName: 'Comp:WhyUsPage',
                content: JSON.stringify(whyUsContent),
            },
        ],
    },
};

export default whyUsMock;
